import React from "react";
import { useLang } from "../contexts/LangContext";
import { t } from "../i18n/translations";

const PORTRAIT = "https://customer-assets.emergentagent.com/job_massage-portal-6/artifacts/lhkqyz7i_regula1-1.webp";

export default function About() {
  const { lang } = useLang();
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20" data-testid="about-page">
      <div className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">— {t(lang, "about.title")}</div>
      <h1 className="font-display text-5xl lg:text-6xl text-ink leading-tight max-w-3xl">{t(lang, "about.lead")}</h1>

      <div className="mt-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="aspect-[4/5] overflow-hidden rounded-md bg-muted">
            <img src={PORTRAIT} alt="Regula Müller" className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="lg:col-span-7 lg:pt-8">
          <h2 className="font-display text-4xl text-terracotta leading-tight">{t(lang, "about.name")}</h2>
          <p className="mt-6 text-ink leading-relaxed text-lg">{t(lang, "about.body")}</p>
          <p className="mt-5 text-ink-muted leading-relaxed">{t(lang, "about.body2")}</p>

          <div className="mt-12 pt-8 border-t border-border">
            <h3 className="font-display text-2xl text-ink mb-4">{t(lang, "about.qual_title")}</h3>
            <ul className="space-y-3 text-ink-muted">
              <li className="flex gap-3"><span className="text-terracotta">◈</span><span>{t(lang, "about.qual_1")}</span></li>
              <li className="flex gap-3"><span className="text-terracotta">◈</span><span>{t(lang, "about.qual_2")}</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
